import {
  BrowserRouter as Router,
  Routes,
  Route,
  useParams,
} from "react-router-dom";

import MainLayout from "./components/Layout/MainLayout"; 
import AgentPage from "./components/Agent/AgentPage";
import AgentProvider from "./context/AgentContext";
import { ThemeProvider } from "./context/ThemeContext";
import { LanguageProvider } from "./context/LanguageContext";
import LoginPage from "./components/Login/LoginPage";
import SignUpPage from "./components/Login/SignUpPage";
import ResetPasswordPage from "./components/Login/ResetPasswordPage";
import LandingPage from "./components/LandingPage";
import ProtectedRoute from "./components/ProtectedRoute";
import Dashboard from "./components/Dashboard/Dashboard"; 
import AdminDashboard from "./components/Admin/AdminDashboard";
import RLHFDashboard from "./components/Admin/RLHFDashboard";
import UserAnalytics from "./components/Admin/UserAnalytics";

function Agent() {
  const { agentId } = useParams();
  return <AgentPage agentId={agentId} />;
}

function AppLayout() {
  // Kita gak butuh useLocation lagi buat nge-hide sidebar manual.
  // Caranya sekarang: Bungkus halaman yang butuh sidebar pakai <MainLayout>

  return (
    <Routes>
      {/* === PUBLIC ROUTES (Tanpa Sidebar/MainLayout) === */}
      <Route path="/" element={<LandingPage />} />
      <Route path="/login" element={<LoginPage />} />
      <Route path="/signup" element={<SignUpPage />} />
      <Route path="/reset-password" element={<ResetPasswordPage />} />

      {/* === PROTECTED ROUTES (Pakai MainLayout) === */}
      
      {/* 1. Dashboard */}
      <Route
        path="/dashboard"
        element={
          <ProtectedRoute>
            {/* MainLayout ini yang bikin Sidebar diem & Konten scroll */}
            <MainLayout>
              <Dashboard />
            </MainLayout>
          </ProtectedRoute>
        }
      />

      {/* 2. Agent Page */}
      <Route
        path="/agents/:agentId"
        element={
          <ProtectedRoute>
            <MainLayout>
              <Agent />
            </MainLayout>
          </ProtectedRoute>
        }
      />

      {/* 3. Admin Dashboard (Token Usage) */}
      <Route
        path="/admin"
        element={
          <ProtectedRoute adminOnly={true}>
            <MainLayout>
              <AdminDashboard />
            </MainLayout>
          </ProtectedRoute>
        }
      />

      {/* 4. RLHF Dashboard */}
      <Route
        path="/admin/rlhf"
        element={
          <ProtectedRoute adminOnly={true}>
            <MainLayout>
              <RLHFDashboard />
            </MainLayout>
          </ProtectedRoute>
        }
      />

      {/* 5. User Analytics */}
      <Route
        path="/admin/users"
        element={
          <ProtectedRoute adminOnly={true}>
            <MainLayout>
              <UserAnalytics />
            </MainLayout>
          </ProtectedRoute>
        }
      />
    </Routes>
  );
}

export default function App() {
  return (
    <ThemeProvider>
      <LanguageProvider>
        <AgentProvider>
          <Router>
            <AppLayout />
          </Router>
        </AgentProvider>
      </LanguageProvider>
    </ThemeProvider>
  );
}